import React from "react";
import { IngestionJob } from "../../api/ingestionJob";
import { AddCreditNoteStep } from "./add-credit-notes-step";
import { ConfirmCreditNotesDataStep } from "./confirm-credit-notes-data-step";
import { InblockedCreditNotesDataStep } from "./inblocked-credit-notes-data-step";

export const CreditNotesWorkflow = ({ isEdit, workflowStep, job, next, back, cancel, startOver, $refreshEvents }:
    { isEdit: boolean, workflowStep: number, job: IngestionJob, next, back, cancel, startOver, $refreshEvents }) => {

    const isAddCreditNotesStepEnabled = () => {
        if (isEdit) return false;

        return workflowStep === 1;
    }

    const isConfirmCreditNotesDataStepEnabled = () => {
        if (isEdit && workflowStep == 0) return true;

        return workflowStep === 2;
    }

    const isInblockedCreditNotesDataStepEnabled = () => {
        if (isEdit && workflowStep == 1) return true;

        return workflowStep === 3;
    }

    return <>
        {isAddCreditNotesStepEnabled() && <AddCreditNoteStep job={job} next={next} back={back} cancel={cancel} />}
        {isConfirmCreditNotesDataStepEnabled() && <ConfirmCreditNotesDataStep isEdit={isEdit} job={job} next={next} cancel={cancel} startOver={startOver} $refreshEvents={$refreshEvents} />}
        {isInblockedCreditNotesDataStepEnabled() && <InblockedCreditNotesDataStep job={job} back={back} $refreshEvents={$refreshEvents} />}
    </>
}
